import { ApplicationsPageContent } from ".";

export default function AffiliateApplicationsPage() {
  return <ApplicationsPageContent activeTab="affiliate" />;
}
